<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('suppliers.billing_address') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.name') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.name !=null">{{ viewSupplier.billing_address.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.country') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.country !=null">{{ viewSupplier.billing_address.country.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.state') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.state !=null">{{ viewSupplier.billing_address.state }}</p>
          </div>
           <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.city') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.city !=null">{{ viewSupplier.billing_address.city }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_1') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.address_street_1 !=null">{{ viewSupplier.billing_address.address_street_1 }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('general.street_2') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.address_street_2 !=null">{{ viewSupplier.billing_address.address_street_2 }}</p>
          </div>


           <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.phone') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.phone !=null">{{ viewSupplier.billing_address.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('suppliers.zip_code') }}</label>
            <p v-if="viewSupplier && viewSupplier.billing_address && viewSupplier.billing_address.zip !=null">{{ viewSupplier.billing_address.zip }}</p>
          </div>
        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    ...mapGetters('supplier', [
      'viewSupplier'
    ]),
  },
  created () {
    this.fetchViewSupplier(this.$route.params.id)
  },
  validations: {},
  mounted () {},
  methods: {
    ...mapActions('supplier', [
      'fetchViewSupplier'
    ])
  }
}
</script>
